<div class="d-flex flex-column h-100">
    @if(isDashboardAdmin) {
    <rask-dashboard-admin></rask-dashboard-admin>
    }

    @if(data()){
    <div
        #container
        class="dashboard-widget-container">
        @for(widget of data(); track widget.id) {
        @let cell = getRenderDimensions(widget.dimensions);
        <div
            cdkDrag
            [cdkDragDisabled]="locked()"
            (cdkDragStarted)="onDragStarted($event, widget)"
            (cdkDragEnded)="onDragEnded($event, widget)"
            (cdkDragMoved)="onDragMoved($event, widget)"
            class="dashboard-widget"
            [style.top.px]="cell.row"
            [style.left.px]="cell.column"
            [style.width.px]="cell.width"
            [style.height.px]="cell.height">
            @if (getWidgetComponent(widget.component); as widgetComponent) {
            <ng-container *ngComponentOutlet="widgetComponent; inputs: widget.properties"></ng-container>
            } @else {
            <ng-container *ngTemplateOutlet="unregisteredErrorTemplate() || defaultWidgetErrorTemplate; context: {
                message: `Widget component '${widget.component}' is not registered in the dashboard configuration.`
            }">
            </ng-container>
            }
        </div>
        }
        @if(preview()) {
        @let cell = getRenderDimensions(preview());
        <div
            class="dashboard-widget preview"
            [style.top.px]="cell.row"
            [style.left.px]="cell.column"
            [style.width.px]="cell.width"
            [style.height.px]="cell.height">
        </div>
        }
    </div>
    }
</div>

<ng-template #defaultWidgetErrorTemplate let-message="message">
    <div class="dashboard-widget-error">
        {{message}}
    </div>
</ng-template>